import Image from "next/image";
import { Box, HStack, Stack } from "@chakra-ui/react";
import TickImage from "public/shared/check-box.png";
import { Text } from "@/elements";

export type SimpleListProps = {
  points: string[];
};

const SimpleList = ({ points }: SimpleListProps) => {
  return (
    <Box>
      <Stack gap={2}>
        {points.map((point, index) => (
          <HStack key={index} align={"start"}>
            <Image
              alt="Point"
              src={TickImage}
              width={20}
              height={20}
              style={{ paddingTop: "4px" }}
            />{" "}
            <Text variant={"body2"} style={{ lineHeight: "24px" }} color="inherit">
              {point}
            </Text>
          </HStack>
        ))}
      </Stack>
    </Box>
  );
};

export default SimpleList;
